module.exports = __webpack_public_path__ + "img/assignment_outlined.d2861e84.svg";